<div class="modal-wrapper">
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Confirm dialog</h4>
    <i
    class="fas fa-times clickable"
    (click)="activeModal.dismiss('Cross click')"
  ></i>
  </div>
  <div class="modal-body">
    <div class="list-title" i18n="@@buildinggroup.removebuildinggroups">
      Are you sure you want to remove the building groups from:
    </div>
    <ul class="list">
      <li class="list-item" *ngFor="let building of buildings">
        {{ building.street }} {{ building.number }} {{ building.suffix }},
        {{ building.postalCode }} {{ building.city }}
      </li>
    </ul>
  </div>
  <div class="modal-footer">
    <div
      class="btn btn-primary"
      (click)="onDecision(true)"
      i18n="@@general.actionbutton.confirm"
    >
      Confirm
    </div>
    <div
      class="btn btn-secondary"
      (click)="onDecision(false)"
      i18n="@@general.actionbutton.cancel"
    >
      Cancel
    </div>
  </div>
</div>
